

// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./sc2024-feature.css";

// *************************************************** Insert Summer Camp 2024 Feature **************************************************** //

class SC2024Feature extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

<!-- *********************************** BEGIN: SUMMER CAMP 2024 *************************************** -->

  <div class="sc24-container container">

  <!-- ************** BEGIN: Title & Pink + Blue Logos ************** -->

    <div class="row">

      <div class="col-lg-12 text-center mb-4">

      <span class="col-3 col-md-2 col-lg-1 badge badge-dark-purple text-white mt-4">
        <img src="assets/icons/white-brackets.png" height="30px" alt="html brackets">
      </span>

        <p class="section-title-size serif-heading bold mx-auto text-center mt-2 pb-0 mb-0 text-white">
          Summer Camp 2024
        </p>

        <p class="section-title-size serif-heading bold mx-auto text-center mt-0 pt-0 pb-0 mb-2 text-white">
          More Than We Imagined!
        </p>

      </div>

      <div class="pink-logo col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

        <a href="" class="polaroid-logo img8"><img src="assets/logos/gcs-logo-pink-background.png" alt=""></a>

      </div>

      <div class="blue-logo col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

        <a href="" class="polaroid-logo img8"><img src="assets/logos/gcs-blue-logo.png" alt=""></a>

      </div>

    </div>

  <!-- ************** END: Title & Pink + Blue Logos ************** -->


  <!-- ***************** BEGIN: Polaroid Photos ****************** -->

  <div class="photo-album px-0">

    <div class="row col-12 d-flex justify-content-center mx-auto">

      <!-- ************** BEGIN: Photos Group 1 ************** -->

      <div class="row col-12 col-tablet-6 col-lg-3">

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="medium-wide medium-wide-1 polaroid drop-shadow img1">
            <img src="assets/summer-camp-2024/polaroids/sc2024-returning-class-b.jpg" alt="">
          </a> 

        </div>

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="medium-wide medium-wide-2 polaroid drop-shadow img2">
          <img src="assets/summer-camp-2024/polaroids/sc2024-beginner-class-b.jpg" alt="">MORE GIRLS</br>(AND MORE BOYS)!</a>

          <a href="/summer-camp-2024" class="polaroid drop-shadow img3">
          <img src="assets/summer-camp-2024/polaroids/sc2024-beginner-class-a.jpg" alt=""></a>

        </div>

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

           <a href="/summer-camp-2024" class="medium polaroid drop-shadow img4">
           <img src="assets/summer-camp-2024/polaroids/sc2024-binary-bracelets.jpg" alt="">MORE CLASSES!</a>

        </div>

      </div> <!-- Photos Group 1 -->

      <!-- ************** END: Photos Group 1 ************** -->

      <!-- ************** BEGIN: Photos Group 2 ************** -->

      <div class="row col-12 col-tablet-6 col-lg-3">

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="large polaroid drop-shadow img5">
          <img src="assets/summer-camp-2024/polaroids/sc2024-reilly-students.jpg" alt="">MORE INSTRUCTORS!</a>

        </div>

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="medium polaroid drop-shadow img6">
          <img src="assets/summer-camp-2024/polaroids/zoe-teaching.jpg" alt=""></a>

        </div>

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="polaroid drop-shadow img7">
          <img src="assets/summer-camp-2024/polaroids/sc2024-payton-students.jpg" alt=""></a>
       
        </div> 

      </div> <!-- Photos Group 2 -->

      <!-- ************** END: Photos Group 2 ************** -->

      <!-- ************** BEGIN: Photos Group 3 ************** -->

      <div class="row col-12 col-tablet-6 col-lg-3">

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="small polaroid drop-shadow img8">
          <img src="assets/summer-camp-2024/polaroids/kristie-calise-headshot-square.jpg" alt="">MORE SPEAKERS!</a>

        </div>

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="large large-2 polaroid drop-shadow img9">
          <img src="assets/summer-camp-2024/polaroids/sc2024-girls-coding.jpg" alt="">MORE CODING!</a>

        </div>

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="medium polaroid drop-shadow img10">
          <img src="assets/summer-camp-2024/polaroids/sc2024-students-at-computers-1.jpg" alt="">MORE COMPUTERS!</a>
        
        </div>

      </div> <!-- Photos Group 3 -->

      <!-- ************** END: Photos Group 3 ************** -->

      <!-- ************** BEGIN: Photos Group 4 ************** -->

       <div class="row col-12 col-tablet-6 col-lg-3">

         <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="polaroid drop-shadow img11">
          <img src="assets/summer-camp-2024/polaroids/sc2024-girls-smiling.jpg" alt=""></a>

        </div>
        
        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="large large-2 polaroid drop-shadow img12">
          <img src="assets/summer-camp-2024/polaroids/sc2024-student-website-1.jpg" alt="">MORE WEBSITES!</a>

        </div>

        <div class="col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1">

          <a href="/summer-camp-2024" class="medium polaroid drop-shadow img13">
          <img src="assets/summer-camp-2024/polaroids/sc2024-lesli-daniette-hug-half.jpg" alt="">MORE JOY!</a>

        </div>

      </div>  <!-- Photos Group 4 -->

      <!-- ************** END: Photos Group 4 ************** -->

    </div>

  </div> <!-- photo album -->

<!-- ************** END: Polaroid Photos ************** -->


<!-- ************** BEGIN: Summer Camp 2024 - Button & Sponsors ************** -->

    <div class="row col-12 col-lg-10 d-flex justify-content-center mt-1 mb-3 text-center mx-auto">

    <!-- ************* BEGIN: Summer Camp 2024 Button *********** -->

    <div class="button text-center mt-5">
      <a href="/summer-camp-2024">
        <button type="button" class="hero-button-3 btn bg-hot-pink text-white">CHECK OUT SUMMER CAMP 2024</button>
      </a>
    </div>

    <!-- ************* END: Summer Camp 2024 Button *********** -->



  <!-- *************** BEGIN: Summer Camp 2024 Sponsors ************ -->
  <div class="col-12 px-0 mt-3">     

    <div class="d-flex justify-content-center mb-4">
      <p class="thank-you-text serif-heading bold mx-auto text-center m-2 text-size-secondary-heading text-white">
        Thank You to Our Summer Camp 2024 Sponsors & Supporters!
      </p>
    </div>

    <!-- BEGIN: Sponsor Logo Section -->
    <div class="container px-2 mb-4">
      <div class="row g-3 justify-content-center align-items-center text-center">
        
        <!-- 1. GA Southern -->
        <div class="col-6 col-sm-4 col-md-3 col-xxl-2">
          <a href="https://georgiasouthern.edu" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
            <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/gsu-logo-with-border.jpg" alt="georgia southern university logo">
          </a>
        </div>

        <!-- 2. BIG -->
        <div class="col-6 col-sm-4 col-md-3 col-xxl-2">
          <a href="https://research.georgiasouthern.edu/big" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
            <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/business-innovation-group.jpg" alt="georgia southern business innovation group logo">
          </a>
        </div>

        <!-- 3. BJ Photography -->
        <div class="col-6 col-sm-4 col-md-3 col-xxl-2">
          <a href="https://budjohnsonphotography.com" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
            <img class="bj-logo img-fluid sponsor-logo-img" src="assets/sponsor-logos/bud-johnson-photography.png" alt="bud johnson photography logo">
          </a>
        </div>

        <!-- 4. Howmet -->
        <div class="col-6 col-sm-4 col-md-3 col-xxl-2">
          <a href="https://www.howmet.com/foundation" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
            <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/howmet-aerospace.png" alt="howmet aerospace logo">
          </a>
        </div>

        <!-- 5. Howmet Women's -->
        <div class="col-6 col-sm-4 col-md-3 col-xxl-2">
          <a href="https://www.howmet.com/diversity-equity-inclusion" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
            <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/howmet-womens-network.png" alt="howmet women's network logo">
          </a>
        </div>

      </div>
    </div>
    <!-- END: Sponsor Logo Section -->

  </div>
  <!-- *************** END: Summer Camp 2024 Sponsors ************ -->

</div>


  </div>

<!-- ****************************************** END: SUMMER CAMP 2024 *********************************************** -->

    `
  }
}


// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('sc2024-feature', SC2024Feature);